<template>
  <div class="solar-cell-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>P = U · I | η = P_out / P_in$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="220" viewBox="0 0 400 220">
          <!-- Sunlight -->
          <g v-if="lightIntensity > 0">
             <line v-for="n in 8" :key="'l'+n" :x1="20 + n*40" y1="0" :x2="10 + n*40" y2="60" stroke="#ffd700" :opacity="lightIntensity/100" />
          </g>

          <!-- PN Junction (Solar Cell Layer) -->
          <rect x="50" y="60" width="300" height="20" fill="#2c3e50" stroke="#34495e" rx="2" />
          <rect x="50" y="80" width="300" height="20" fill="#2980b9" stroke="#3498db" rx="2" />
          
          <!-- Electrons Moving (if light is on) -->
          <g v-if="lightIntensity > 30">
             <circle v-for="n in 10" :key="'e'+n" :cx="60 + n*28" :cy="75" r="2" fill="#2ed573">
                <animate attributeName="cx" :from="60 + n*28" :to="60 + n*28 + 20" dur="1s" repeatCount="indefinite" />
             </circle>
          </g>

          <!-- Circuit to the Load (Bulb) -->
          <path d="M 50 70 L 20 70 L 20 180 L 150 180" fill="none" stroke="#888" />
          <path d="M 350 90 L 380 90 L 380 180 L 250 180" fill="none" stroke="#888" />

          <!-- Bulb -->
          <g transform="translate(180, 160)">
             <circle cx="20" cy="20" r="15" :fill="lightIntensity > 10 ? '#ffd700' : '#333'" :opacity="lightIntensity/100" />
             <path d="M 12,25 Q 20,10 28,25" fill="none" :stroke="lightIntensity > 10 ? '#fff' : '#555'" />
             <text x="20" y="55" text-anchor="middle" fill="#888" font-size="8">负载 (灯泡)</text>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>光照强度: {{ lightIntensity }}%</label>
              <div class="value">输出电流 I ∝ P_light</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>控制入射光强</label>
             <el-slider v-model="lightIntensity" :min="0" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>太阳能电池利用**光生伏特效应**。光子能量被PN结吸收，激发出电子-空穴对。PN结的内建电场驱动它们向相反方向运动，从而在外部电路产生电流。这是利用可再生能源的最直接方式。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SolarCellViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      lightIntensity: 60
    }
  }
}
</script>

<style scoped lang="scss">
.solar-cell-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.hud-top { position: absolute; top: 15px; left: 15px; }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; 
  label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } 
}
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
